import { render, staticRenderFns } from "./PageSearch.vue?vue&type=template&id=5395202b&"
import script from "./PageSearch.vue?vue&type=script&lang=js&"
export * from "./PageSearch.vue?vue&type=script&lang=js&"
import style0 from "./PageSearch.vue?vue&type=style&index=0&id=5395202b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports